import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ColorSwatch = ({ name, active, mediaURL, onChange, seoUrl, onClick }) => {
  const intl = useIntl();
  return (
    <li
      className={`pdp__color-swatches-color-swatch ${active ? '_is-active' : ''}`}
      onMouseEnter={() => onChange(name)}
      onMouseLeave={() => onChange(null)}
    >
      <button
        aria-label={`${intl.formatMessage({
          id: 'products.pdp.colorswatches.color.choose',
        })} ${name}`}
        type="button"
        className="button-reset js-tracking-color-swatches"
        data-tracking-name={name}
        onClick={() => onClick(seoUrl)}
      >
        <img className="pdp__color-swatches-color-swatch-image" src={mediaURL} alt={name} />
      </button>
    </li>
  );
};

ColorSwatch.propTypes = {
  name: PropTypes.string.isRequired,
  seoUrl: PropTypes.string.isRequired,
  mediaURL: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ColorSwatch;
